var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 766,
    height: 1062,
    viewBox: "0 0 766 1062",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.162 13.7132C340.201 4.03528 365.039 -0.617435 390.018 0.0656715C414.994 0.748686 439.537 6.75019 462.01 17.6699L682.506 124.75C706.644 133.796 727.524 149.897 742.413 170.983C757.736 192.683 765.961 218.596 765.958 245.16V376.468H691.186V245.154C691.188 234.037 687.746 223.193 681.334 214.112C674.922 205.032 665.854 198.16 655.377 194.443L653.417 193.747L429.346 84.9302L429.341 84.9279L429.337 84.9256C416.425 78.6509 402.324 75.2023 387.974 74.8099C373.624 74.4175 359.356 77.0903 346.121 82.65L115.481 179.541L113.454 180.134C102.289 183.403 92.4845 190.204 85.5105 199.515C78.5366 208.827 74.7686 220.148 74.772 231.782V356.073C84.7303 425.187 152.198 577.178 350.227 619.033L351.404 619.28L352.347 619.477L726.228 717.819L707.208 790.132L335.164 692.272C96.4255 642.011 12.161 455.048 0.308909 363.409L2.73064e-06 361.021V231.792C-0.00572467 203.994 8.9984 176.942 25.6628 154.692C41.8698 133.053 64.473 117.089 90.2421 109.041L317.162 13.7136L317.162 13.7132Z",
    fill: "url(#paint0_linear_642_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M638.779 491.303C676.522 510.022 708.325 538.869 730.625 574.629C753.109 610.683 765.032 652.32 765.042 694.811C765.073 699.544 764.673 704.27 763.844 708.931L763.802 709.166L763.758 709.401C758.916 734.754 745.674 763.242 728.034 791.627C710.04 820.58 686.033 851.714 657.312 882.609C599.971 944.291 522.1 1006.89 432.032 1049.81L431.882 1049.89C416.718 1057.03 400.2 1060.84 383.439 1061.07C366.741 1061.3 350.188 1057.95 334.886 1051.27C281.759 1028.39 205.21 990.226 138.99 938.174C73.6923 886.847 12.1671 817.074 1.19897 729.79L0.907227 727.469V631.773H75.6793V722.652C83.7308 779.671 125.93 832.802 185.198 879.389C243.351 925.1 312.107 959.896 362.145 981.597L364.513 982.621L364.629 982.671L364.744 982.721C370.316 985.165 376.346 986.387 382.43 986.305C388.499 986.223 394.48 984.844 399.973 982.263C480.139 944.035 550.549 887.635 602.548 831.7C628.508 803.774 649.443 776.431 664.526 752.159C679.824 727.544 687.788 708.187 690.247 695.712C690.265 695.57 690.274 695.427 690.272 695.284L690.27 695.056V694.827C690.263 666.319 682.263 638.384 667.179 614.195C652.094 590.005 630.528 570.53 604.931 557.981L604.039 557.544L43.7864 244.969L80.2168 179.672L638.779 491.303Z",
    fill: "url(#paint1_linear_642_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_642_167",
    x1: 576.887,
    y1: 697.948,
    x2: 662.965,
    y2: 781.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE53D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE53D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_642_167",
    x1: 172.551,
    y1: 275.358,
    x2: 76.3554,
    y2: 230.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DDBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DDBE1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.538406ba5a2f321a52edb9f853586aeb.svg";
export { ForwardRef as ReactComponent };